import { render, staticRenderFns } from "./LeaveNoteDialog.vue?vue&type=template&id=2030a4d6&scoped=true"
import script from "./LeaveNoteDialog.vue?vue&type=script&lang=js"
export * from "./LeaveNoteDialog.vue?vue&type=script&lang=js"
import style0 from "./LeaveNoteDialog.vue?vue&type=style&index=0&id=2030a4d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2030a4d6",
  null
  
)

export default component.exports